<template>
    <div class="home-component">
        <div class="title-block">
            <div class="title-block__left">
                <div class="title-block__title">
                    Документация
                </div>
            </div>
        </div>

        <div class="docs-content">
            <a
                :href="documentation_path"
                class="docs-link"
            >
                <span class="docs-link__text">Перейти к документации</span>
                <span class="docs-link__arrow">→</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "HomeComponent",
    props: {
        documentation_path: String
    },
}

</script>

<style scoped>
.home-component {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.title-block {
    margin-bottom: 30px;
}

.title-block__title {
    font-size: 28px;
    font-weight: 500;
    color: #1a1a1a;
}

.docs-content {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

.docs-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: transparent;
    color: #0678F4;
    text-decoration: none;
    border: 1px solid #0678F4;
    border-radius: 8px;
    font-size: 18px;
    transition: all 0.2s;
    cursor: pointer;
}

.docs-link:hover {
    background: #0678F4;
    color: white;
    gap: 12px;
    padding: 12px 28px;
}

.docs-link__arrow {
    transition: transform 0.2s;
}

.docs-link:hover .docs-link__arrow {
    transform: translateX(4px);
}
</style>
